import { delay, takeLatest, put, all, select, call, fork, take, cancelled, takeEvery } from "redux-saga/effects";
import io from 'socket.io-client';
import { eventChannel } from 'redux-saga';

export const getState = (state) => state;

let socket;
const connect = (socketServerURL, cHash, uuid, tagId) => {
  socket = io(socketServerURL, {
    upgrade: false,
    transports: ['websocket'],
    query: 'uuid='+uuid+'&cHash='+cHash+'&tagId='+tagId,
    timeout: 2000,
    path: '/websocket/'
  });
  return new Promise((resolve) => {
    socket.on('connect', () => {
      resolve(socket);
    });
    socket.on('connect_error', (err) => {
      console.log('connection error');
      console.log(err);
    });
  });
};

const disconnect = () => {
  return new Promise((resolve) => {
    socket.on('disconnect', () => {
      resolve(socket);
    });
  });
};

const reconnect = () => {
  return new Promise((resolve) => {
    socket.on('reconnect', () => {
      resolve(socket);
    });
  });
};

const connected = () => {
  return new Promise((resolve) => {
    socket.on('connect', () => {
      resolve(socket);
    });
  });
};

const createSocketChannel = socket => eventChannel((emit) => {
  const handler = (data) => {
    emit(data);
  };
  
  socket.on('message', handler);
  socket.on('message_replace', handler);
  socket.on('readed', handler);
  socket.on('status', handler);
  socket.on('start_typing', handler);
  socket.on('end_typing', handler);
  socket.on('new_user', handler);
  socket.on('status_change', handler);
  socket.on('client_readed', handler);
  socket.on('company_status', handler);
  socket.on('message_conversation_removed', handler);
  socket.on('talk_to_human_removed', handler);
  socket.on('channel_disable', handler);
  socket.on('channel_enable', handler);
  socket.on('button_clicked', handler);

  socket.on('error', function (err) {
    console.log('error');
  });

  return () => {
    socket.off();
  };
});

// connection monitoring sagas
const listenDisconnectSaga = function* () {
  while (true) {
    console.log('disconect');
    yield call(disconnect);
    console.log('disconect2');
    yield put({ type: 'SERVER_OFF' });
  }
};

const listenReconnectSaga = function* () {
  while (true) {
    console.log('reconnect loop0');
    yield call(reconnect);
    console.log('reconnect loop1');
    yield put({ type: 'SERVER_ON' });
    console.log('reconnect loop');
  }
};

const listenConnectSaga = function* () {
  while (true) {
    console.log('connect loop0');
    yield call(connected);
    console.log('connect loop1');
    yield put({ type: 'SERVER_ON' });
    console.log('connect loop');
  }
};

// Saga to switch on channel.
const listenServerSaga = function* () {
  try {
    const getUuid = (state) => state.uuid.uuid;
    const uuid = yield select(getUuid);

    const getCHash = (state) => state.app.cHash;
    const cHash = yield select(getCHash);

    const getChatUrl = (state) => state.app.chatUrl;
    const socketServerURL = yield select(getChatUrl);

    const getTagId = (state) => state.app.tagId;
    const tagId = yield select(getTagId);

    const socket = yield call(connect, socketServerURL, cHash, uuid, tagId);

    yield put({ type: 'SERVER_ON' });

    console.log(socket);

    const socketChannel = yield call(createSocketChannel, socket);
    yield fork(listenConnectSaga);
    yield fork(listenDisconnectSaga);
    yield fork(listenReconnectSaga);


    while (true) {
      console.log('----');
      console.log('websocket');
      const payload = yield take(socketChannel);
      console.log(payload);
      console.log('----');

      switch (payload.message.event) {
        case 'message':
          yield put({type: 'NEW_MESSAGE', payload});
          yield put({type: 'READ_MESSAGES', payload});
          break;
        case 'message_replace':
          yield put({type: 'REPLACE_MESSAGE', payload});
          break;
        case 'status_change':
          yield put({type: 'STATUS_CHANGE', payload});
          break;
        case 'status':
          yield put({type: 'USER_STATUS', payload});
          break;
        case 'start_typing':
          yield put({type: 'USER_START_TYPING', payload});
          break;
        case 'end_typing':
          yield put({type: 'USER_END_TYPING', payload});
          break;
        case 'client_readed':
          yield put({type: 'READED_MESSAGE', payload});
          break;
        case 'company_status':
          yield put({type: 'COMPANY_STATUS', payload});
          break;
        case 'message_conversation_removed':
          yield put({type: 'MESSAGE_CONVERSATION_REMOVED', payload});
          break;
        case 'talk_to_human_removed':
          yield put({type: 'TALK_TO_HUMAN_SUCCESS', payload});
          break;
        case 'channel_disable':
          yield put({type: 'CHANNEL_DISABLE', payload});
          break;
        case 'channel_enable':
          yield put({type: 'CHANNEL_ENABLE', payload});
          break;
        case 'button_clicked':
          yield put({type: 'BUTTON_CLICKED', payload});
          break;
        default:
          console.log('Not found');
      }
    }

  } catch (error) {
    console.log(error);
  } finally {
    if (yield cancelled()) {
      socket.disconnect(true);
      yield put({type: 'SERVER_OFF'});
    }
  }
};

export const startStopChannel = function* () {
  yield call(listenServerSaga);
};

export const watchSendTyping = function* () {
  yield takeEvery('SEND_CLIENT_START_TYPING', function*(action){
    socket.emit('client_start_typing', {
      'channel': action.channel,
      'uuid': action.uuid
    })
  });
};

export const watchSendEndTyping = function* () {
  yield takeEvery('SEND_CLIENT_END_TYPING', function*(action){
    socket.emit('client_end_typing', {
      'channel': action.channel,
      'uuid': action.uuid
    })
  });
};

export const watchUserStatusChange = function* ()  {
  yield takeLatest('USER_STATUS', function*(action) {
    yield put({ type: 'SET_USER_STATUS', status: action.payload.message.status, userId: action.payload.message.userId });
  });
};

export const watchGetUsersStatus = function* () {
  yield takeLatest('LOAD_MESSAGES_SUCCESS', function*(action) {
    socket.emit('company_status');
    socket.emit('client_users_status');
  });
};

export const watchNewMessageForStatus = function* () {
  yield takeLatest('NEW_MESSAGE', function*(action) {
    if (action.payload.message.fromClient) {
      return;
    }

    const getOperatorStatus = (state) => state.app.operatorStatus;
    const operatorStatus = yield select(getOperatorStatus);

    if (operatorStatus) {
      return;
    }

    socket.emit('client_users_status');
    console.log(action, 'new message');
  });
  
};